export default __webpack_public_path__ + "static/media/sidxo.22a91bb2.gif";